import { memo } from "preact/compat";
import { Typography } from "../../shared/ui";
import { NumberInput } from "../../shared/ui/NumberInput";
import { createPressHandlers } from "../../shared/utils/pressHandlers";
import css from "./ControlPanel.module.scss";

const QUICK_BET_AMOUNTS = [1, 2, 5, 10] as const;

interface BetInputSectionProps {
  betAmount: number;
  maxBetAmount: number;
  isBlocked: boolean;
  onBetAmountChange: (value: number) => void;
  onQuickBet: (amount: number) => void;
}

export const BetInputSection = memo(function BetInputSection({
  betAmount,
  maxBetAmount,
  isBlocked,
  onBetAmountChange,
  onQuickBet,
}: BetInputSectionProps) {
  return (
    <div className={`${css.betInputSection} ${isBlocked ? css.blocked : ""}`}>
      <NumberInput
        value={betAmount}
        min={0.1}
        max={maxBetAmount}
        step={0.1}
        onChange={onBetAmountChange}
      />

      <div className={css.quickBetGrid}>
        {QUICK_BET_AMOUNTS.map((amount) => (
          <button
            key={amount}
            className={css.quickBetButton}
            {...createPressHandlers(() => onQuickBet(amount))}
          >
            <Typography variant="caption2" color="header">
              {amount}
            </Typography>
          </button>
        ))}
      </div>
    </div>
  );
});
